import React, { useState, useEffect, useRef } from 'react';

import defaultStates from '../../../../src-component/defaultStates';
import { getNaturalTimeString, ajaxor2, isLogon } from '../../../common/basic';

export default props => {
  if (!props.me) return <></>;
  // console.log("item: ", props.me);

  useEffect(() => {
    // console.log("item useEffect: ", props.me);

    return () => { ; };
  }, [props.me]);

  const [vScrapped, setScrapped] = useState(props.me && props.me.collected);

  return (<div className=" p6CCList-item item-panel seed" lcg={props.me.id}>
    <style jsx>{`
.image0 {
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}


.m15.image0 {
  height: 100%;
  width: auto;
}

img {
  vertical-align: top;
}

.seed{
  font-family: NotoSansCJKkr;
  font-size: 14px;
}

  // padding-top: 14px;

.l1{
  width: 416px;
  height: 500px;
  line-height: 500px;

  background-color: black;

  position: relative;
  overflow: hidden;

}

.l2{
  // 절대위치로 조절
  position: absolute;
  top: 20px;
  right: 40px;

  line-height: 50px;
}

.l3{
  position: absolute;
  top: 20px;
  right: 0;

  line-height: 50px;
}

.l5{
  font-size: 12px;
  color: #868e96;
}

.l5 span, .l5 a {
  vertical-align:middle;
  color: #adb5bd;
}

.img16{
  width:16px;
  margin-top: 3px;
}


.dib{
  display: inline-block;
  // margin:0;

  vertical-align: middle;
}


.brief{
  position: relative;
  padding: 20px 5px;
}

.psa{
  margin-right: 16px;

}

.statistics{
  display:block;
  margin-top: 10px;
}

.r1{
  position: absolute;
  right: 20px;
  bottom: 30px;
}


@media all and (max-width:606px) {

  .psa{
    margin-right: 5px;
  }

  .statistics{
    display:block;
  }


  .r1 {
    /* right: 20px;
    bottom: 130px; */
  }

  .r1 img {
    width:25px;
  }

  .l1{
    height: auto;
    width: auto;
    line-height: normal;
  }

  .image0{
    position: relative;
    width: 100%;
    transform: none;
    left: auto;
    margin-bottom: -5px;
  }
  .m15.image0 {
      width: 100%;
  }

}


`}</style>

    {/* 1. 상단이미지블럭 */}
    <div className="upper">
      <div className="l1">
        <a onClick={props.setDFixedDetail}>
          <img className="image0"
            src={props.me.images[0].optimized_url}

            // lcg 일과이분의일
            onLoad={e => {
              if (e.target.width < e.target.height && e.target.height < e.target.width * 1.2)
                $(e.target).addClass('m15');
            }}

          />
        </a>
        <div className="l2">
          <a onClick={props.likePlus}>
            <img className="리스트의하트 image1" src={
              // vLiked ? "/assets/images/btn-like.svg" : "/assets/images0220/heart.svg"
              props.me.liked ? "/assets/images/btn-like.svg" : "/assets/images0220/heart.svg"
            } />
          </a>
        </div>
        <div className="l3">
          <a onClick={() => {
            if (!isLogon()) return alert("로그인을 하셔야 합니다.");
            ajaxor2({
              url: '/inspiration/collect/' + props.me.id, type: 'post', callback: r => {
                // alert(r.status);
                setScrapped(r.status == "collected");
              }
            });
          }}>
            <img className="image1" src={vScrapped ? "/assets/images/btn-favorite.svg" : "/assets/images3/scrap.svg"} />
            {/* 이미지 사이즈가 달랐을때 쓰던거.
            <img className="icon32" style={{display: (vScrapped?'':'none')}} src="/assets/images3/scrap.svg" />
            <img className="image2" style={{display: (vScrapped?'none':'')}} src="/assets/images/btn-favorite.svg" /> */}
          </a>
        </div>
      </div>
    </div>

    {/* 2. 하단 브리핑블럭 */}
    <div className="lower brief">
      <a href={"/person/Blog?userid=" + (props.me && props.me.user && props.me.user.id)}>
        <div className="dib psa round-psa">
          {/* <img src="/assets/images/pictures/img-profile_3@3x.png" /> */}
          <img src={
            props.me.user && props.me.user.profile_picture[0]
              ? props.me.user.profile_picture[0].optimized_url
              : "/assets/images/ico-empty.svg"}
          />
        </div>
        <div className="dib">
          <div className="nickname">
            {props.me.user && props.me.user.username}
          </div>
        </div>
      </a>

      <div className="statistics">
        <div className="dib l5 disposal">
          <img className="disposal img16" src="/assets/images/time.svg" /><span>{getNaturalTimeString(props.me && props.me.created_at)}</span>&nbsp;&nbsp;
        </div>
        <div className="dib l5">
          <img className="img16" src="/assets/images/heart.svg" />
          <a onClick={props.showLikersPopup}>{props.me.like_count}</a>&nbsp;&nbsp;
        </div>
        <div className="dib l5"><a onClick={() => props.setDFixedDetail('block')}>
          <img className="img16" src="/assets/images2/reply.svg" /><span className={"cc-" + props.me.id} >{props.me && props.me.comment_count}</span>&nbsp;&nbsp;
        </a></div>
      </div>

      {/* todo_01: 첫번째사진에 태그가 있으면 보이기 */}
      {/* images[0].pins[0].category */}
      {props.me.images[0].pins.length > 0 ?
        <div className="dib r1"><a onClick={props.setDClassification}>
          <img src="/assets/images/ico-street.svg" />
        </a></div> : null}

    </div>

    {/* 0418 - 게시물과 게시물 사이 간격 좁혀주기. 너무 멀다. (지금의 1/2) <div>&nbsp;</div> */}
  </div>);
}

